var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M46 60C29.1 60 12.4 47.7 2.3 36.1c-3-3.5-3-8.7 0-12.2C12.5 12.2 29.5-.4 46.6 0h.6C64.1 0 80.8 12.3 91 23.9c3 3.5 3 8.7 0 12.2C80.8 47.7 64.1 60 47.2 60H46zm0-55.4c-15.3 0-30.8 11.5-40.3 22.3-1.5 1.7-1.5 4.4 0 6.1 9.5 10.9 25 22.4 40.3 22.4h1.1C62.5 55.4 78 43.9 87.5 33c1.5-1.7 1.5-4.4 0-6.1C77.9 16 62.1 4.1 46.6 4.6h-.1-.5zm1.5 44.3c-10.4 0-18.9-8.5-18.9-18.9s8.5-18.9 18.9-18.9c5.1 0 9.8 2 13.4 5.5 3.6 3.6 5.5 8.3 5.5 13.4.1 10.4-8.4 18.9-18.9 18.9zm0-33.2A14.3 14.3 0 1 0 61.8 30h0c0-3.8-1.5-7.4-4.2-10.1-2.6-2.7-6.2-4.2-10.1-4.2z"}));
}

Eye.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 93.2 60","overflow":"visible"};

module.exports = Eye;

Eye.default = Eye;
